import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';
const get = (url) => axios.get(`${apiPrefix}${url}`, { withCredentials: true }).then(r => r.data);
const post = (url, data) => axios.post(`${apiPrefix}${url}`, data, { withCredentials: true }).then(r => r.data);

export const useSmartAlerts = () => useQuery({
    queryKey: ['smartAlerts'],
    queryFn: () => get('/readAllSmartAlerts'),
});

export const useSmartAlert = (id) => useQuery({
    queryKey: ['smartAlert', id],
    queryFn: () => get(`/readSmartAlert/${id}`),
    enabled: !!id,
});

export const useSmartAlertRuns = (id) => useQuery({
    queryKey: ['smartAlertRuns', id],
    queryFn: () => get(`/smartAlertRuns/${id}`),
    enabled: !!id,
});

export const useSmartAlertRunDetail = (runId) => useQuery({
    queryKey: ['smartAlertRunDetail', runId],
    queryFn: () => get(`/smartAlertRunDetail/${runId}`),
    enabled: !!runId,
});

export const useCreateSmartAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => post('/createSmartAlert', data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['smartAlerts'] }),
    });
};

export const useUpdateSmartAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => post('/updateSmartAlert', data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['smartAlerts'] }),
    });
};

export const useToggleSmartAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => post('/toggleSmartAlert', data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['smartAlerts'] }),
    });
};

export const useDeleteSmartAlert = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => post('/deleteSmartAlert', data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['smartAlerts'] }),
    });
};
